module.exports = __webpack_public_path__ + "static/implementation-lifecycle-infograph-832b7b0707f6cd003ec20bd82124f66b.png";